/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Bénéficiaire d'une ligne de tarification.
 * @export
 * @interface TarificationBeneficiaireDto
 */
export interface TarificationBeneficiaireDto {
    /**
     * 
     * @type {string}
     * @memberof TarificationBeneficiaireDto
     */
    personneMoraleId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TarificationBeneficiaireDto
     */
    designation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TarificationBeneficiaireDto
     */
    type?: string | null;
}

/**
 * Check if a given object implements the TarificationBeneficiaireDto interface.
 */
export function instanceOfTarificationBeneficiaireDto(value: object): value is TarificationBeneficiaireDto {
    return true;
}

export function TarificationBeneficiaireDtoFromJSON(json: any): TarificationBeneficiaireDto {
    return TarificationBeneficiaireDtoFromJSONTyped(json, false);
}

export function TarificationBeneficiaireDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TarificationBeneficiaireDto {
    if (json == null) {
        return json;
    }
    return {
        
        'personneMoraleId': json['personneMoraleId'] == null ? undefined : json['personneMoraleId'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function TarificationBeneficiaireDtoToJSON(json: any): TarificationBeneficiaireDto {
    return TarificationBeneficiaireDtoToJSONTyped(json, false);
}

export function TarificationBeneficiaireDtoToJSONTyped(value?: TarificationBeneficiaireDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personneMoraleId': value['personneMoraleId'],
        'designation': value['designation'],
        'type': value['type'],
    };
}

